import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export interface PictureServiceFeConfig {
  /** Base URL for the image service (e.g., '/api/image' or 'http://localhost:3003') */
  endpoint: string;
}

export const PICTURE_SERVICE_FE_CONFIG =
  new InjectionToken<PictureServiceFeConfig>('PICTURE_SERVICE_FE_CONFIG');

export function providePictureServiceFe(
  config: PictureServiceFeConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: PICTURE_SERVICE_FE_CONFIG,
      useValue: config,
    },
  ]);
}
